type ArrowRightType = {
  fill: string
  width: string
  height: string
  title: string
}

function ArrowRight(props: ArrowRightType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'upload'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 23 23'
      fill='none'
      className='shrink-0 max-lg:h-[22px] max-lg:w-[22px] max-sm:h-[21px] max-sm:w-[21px]'
    >
      <title>{title}</title>
      <path
        d='M2.39587 11.5H20.125H19.6459'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M13.4167 18.2077L20.1251 11.4993L13.4167 4.79102'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default ArrowRight
